import { QuoteEmail } from "./email.model";
import { BaseQuote } from "./quote-base.model";
import { Client } from "../../client/client.model";
import { BaseUser } from "../../user/base-user.model";

export class ManualQuote extends BaseQuote {
  constructor(
    protected id: number,
    protected displayId: string,
    protected groupId: number,
    protected ref: string,
    protected sender: BaseUser,
    protected createdBy: BaseUser,
    protected status: string,
    protected quoteType: string,
    protected clients: Client[],
    protected createdAt: Date,
    protected updatedAt: Date,
    protected updatedBy: BaseUser,
    protected openedAt: Date,
    protected validFrom: Date,
    protected validTo: Date,
    protected email: QuoteEmail,
    protected internalComment: string,
    protected customTerms: string,
    protected fileName: string,
    protected fileNameInternal: string,
    protected averageMargin: number,
    protected inquiry: string,
    protected source: string,
    protected htmlContent: string = "",
    protected netPrice: number = 0,
    protected margin: number = 0,
    protected manualQuoteType: string = null,
    protected reasonOfDecline: string,
    protected input: string | null,
    protected currency: string = "USD",
  ) {
    super(
      id,
      displayId,
      groupId,
      ref,
      sender,
      createdBy,
      status,
      quoteType,
      clients,
      createdAt,
      updatedAt,
      updatedBy,
      openedAt,
      validFrom,
      validTo,
      email,
      internalComment,
      customTerms,
      fileName,
      fileNameInternal,
      averageMargin,
      inquiry,
      source,
      null,
      reasonOfDecline,
      input,
    );
  }

  public getHtmlContent(): string {
    return this.htmlContent;
  }

  public setHtmlContent(c: string): void {
    this.htmlContent = c;
  }

  public getNetPrice(): number {
    return this.netPrice;
  }

  public setNetPrice(p: number): void {
    this.netPrice = p;
  }

  public getMargin(): number {
    return this.margin;
  }

  public setMargin(m: number): void {
    this.margin = m;
  }

  public getManualQuoteType(): string {
    return this.manualQuoteType;
  }

  public setManualQuoteType(m: string) {
    this.manualQuoteType = m;
  }

  public getCurrency(): string {
    return this.currency;
  }

  public setCurrency(currency: string): void {
    this.currency = currency;
  }

  public isValid(): boolean {
    return (
      super.isValid() &&
      (this.getNetPrice() > 0 ||
        this.getMargin() >= 0 ||
        !!this.getHtmlContent().length)
    );
  }
}
